import { reactive, ref } from 'vue';
import { defineStore } from 'pinia';
import { getProductInfo, getProductNo } from '@common/core/network/NodeAPI';
const product = {
    name: '',
    /** 产品业务编号 */
    proNo: '',
    /** 产品可贷的期数 */
    proLoanTerm: [],
    /** 币种 */
    ccyCode: '',
    /** 还款方式 */
    rpyMethod: '',
    /** 核心产品号 */
    baseProNo: '',
    /** 最小需要贷款的金额 */
    minLoanAmt: '',
    /** 产品状态 3为产品下架 否则正常 */
    proStatus: 0,
    extInfo: {
        limit_max: '',
        limit_min: '',
        rate_max: '',
        rate_min: '',
    },
    proLoanTermNoResidence: [],
    termsNoResidenceDefaultTerm: '',
    termsResidenceDefaultTerm: '',
    productTag: '',
};
export const useProduct = defineStore('useProduct', () => {
    const productState = reactive(product);
    const ready = ref(false);
    const error = reactive({ code: '', message: '' });
    const refreshProduct = async () => {
        const prodNo = getProductNo();
        if (ready.value && prodNo === productState.proNo) {
            return;
        }
        ready.value = false;
        const resp = await getProductInfo();
        ready.value = true;
        Object.assign(productState, resp);
    };
    return {
        productState,
        refreshProduct,
        ready,
        error,
    };
}, {
    // @ts-ignore
    persist: true,
});
export const prodPlugin = {
    install: async () => {
        if (getProductNo()) {
            const productInfoStore = useProduct();
            productInfoStore.refreshProduct();
        }
    },
};
